<template>
  <div ref="homeRef" class="text-paper bg-[#f8f8f8] min-h-screen pt-[48px]">
    <!-- 首屏交互区：立即水合，不做延迟 -->
    <HomeTopLogo class="-mt-12" />
    <HomeMemberSearch class="-mt-[130px]" />

    <!-- 以下：Lazy 异步加载 + 进入视口再水合（rootMargin 提前一点，减少「看见了点不动」） -->
    <LazyVisibleHomeBusinessOpportunity
      class="mt-7"
      :hydrate-on-visible="hydrateOnVisible"
      @click="handleClickOpportunity"
    />

    <LazyVisibleHomeEventModel
      id="bene-Business"
      class="mt-6"
      :hydrate-on-visible="hydrateOnVisible"
    />

    <LazyVisibleHomeFreightType :hydrate-on-visible="hydrateOnVisible" />
    <LazyVisibleHomeBusiness :hydrate-on-visible="hydrateOnVisible" />

    <LazyVisibleHomeFinancialProtection
      id="bene-FinancialProtection"
      :hydrate-on-visible="hydrateOnVisible"
    />

    <LazyVisibleHomeOpportunity
      id="bene-Opportunity"
      :hydrate-on-visible="hydrateOnVisible"
    />

    <LazyVisibleHomeOfficialSettlement :hydrate-on-visible="hydrateOnVisible" />
    <LazyVisibleHomeCosts id="bene-Costs" :hydrate-on-visible="hydrateOnVisible" />
    <LazyVisibleHomeSuccessStory :hydrate-on-visible="hydrateOnVisible" />
    <LazyVisibleHomeTrusted :hydrate-on-visible="hydrateOnVisible" />
    <LazyApplyMemberShip />
  </div>
</template>

<script lang="ts" setup>
  definePageMeta({
    middleware: ['report'],
    headerIsWhite: true,
    name: 'Home',
  })
  const route = useRoute()
  const isShowBannerImg = computed(() => {
    return ['Home'].includes(route.name as string)
  })

  const homeRef = ref()

  /** 进视口（含提前 120px）再水合，自动适配不同手机屏高 */
  const hydrateOnVisible = { rootMargin: '120px 0px' }

  const { isCn } = useVipLogo()
  function handleClickOpportunity(item: any) {
    const targetElement = document.getElementById(`bene-${item.key}`)

    if (targetElement) {
      window.scrollTo({
        behavior: 'smooth',
        top: targetElement.offsetTop - 110,
      })
    }
  }

  useHead({
    title: isCn.value
      ? 'JCtrans杰西圈-全球领先的国际物流货运代理B2B平台'
      : 'JCtrans-The Leading Platform for Freight Forwarders Logistics',
    meta: [
      {
        name: 'description',
        content: isCn.value
          ? `JCtrans杰西圈是全球领先的国际物流B2B平台，以技术与信誉体系赋能货代之间合作，实现询盘、订舱到结算的数据化全链路。提供最新货代物流新闻、市场行情及全球货代企业名录，精准匹配运力供需，依托真实数据构建互信生态,链全球商机，帮货代盈利！`
          : 'JCtrans is a leading platform for freight forwarders logistics company. We are dedicated to providing a highly efficient and convenient platform for global freight forwarders and logistics enterprises, market trends, promoting the development and cooperation of international logistics.',
      },
      {
        name: 'keywords',
        content: isCn.value
          ? '货代平台,国际货代,物流B2B, 货运代理,货代名录,货代合作,物流企业合作,跨境物流, 全球物流网络, 国际物流服务, 货代合作平台'
          : 'JCtrans,logistics platform,freight forwarder,international logistics,freight forwarder,supply chain,logistics directory,logistics news,freight forwarders',
      },
    ],
  })
</script>
